import React from 'react';
import PropTypes from 'prop-types';
import InfoTooltip from '../../../InfoTooltip';
import { debounceTooltipTracking } from '../../debounceTooltipTracking';
import styled from 'styled-components';

const InlineDiv = styled.div`
    display: inline;
`;

export default class TooltipRenderer extends React.Component {
    static propTypes = {
        alt: PropTypes.string,
        src: PropTypes.string,
        title: PropTypes.string,
        trackClickIBubbleClick: PropTypes.func,
    }

    render() {
        const {
            alt,
            src,
            title,
            trackClickIBubbleClick,
        } = this.props;

        const debouncedTrackingFn = debounceTooltipTracking(() => { trackClickIBubbleClick(title); });

        if (src === 'Tooltip.Info') {
            return (
                <InlineDiv data-test="info-tooltip">
                    <InfoTooltip
                        alt={title}
                        onDisplayTooltip={debouncedTrackingFn}
                    >
                        {alt}
                    </InfoTooltip>
                </InlineDiv>
            );
        }

        if (src === 'Tooltip.Accessibility') {
            return (
                <InlineDiv data-test="accessibility-tooltip">
                    <InfoTooltip
                        alt={title}
                        icon="wheelchair"
                        onDisplayTooltip={debouncedTrackingFn}
                    >
                        {alt}
                    </InfoTooltip>
                </InlineDiv>
            );
        }

        return (
            <img
                alt={alt}
                src={src}
                title={title}
            />
        );
    }
}

